import { render, staticRenderFns } from "./messageCodeVerify.vue?vue&type=template&id=4d267aba&scoped=true"
import script from "./messageCodeVerify.vue?vue&type=script&lang=js"
export * from "./messageCodeVerify.vue?vue&type=script&lang=js"
import style0 from "./messageCodeVerify.vue?vue&type=style&index=0&id=4d267aba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d267aba",
  null
  
)

export default component.exports